module.exports = __webpack_public_path__ + "z-g-3-brands-color-r-g-b@2x-1VzRMQ6.jpg";